// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuthenticateTokenQuery } from "../api/useAuthenticateToken";
import api from "../utils/api";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const token = localStorage.getItem("token");

  const { data, isLoading, isError } = useAuthenticateTokenQuery(token, {
    enabled: !!token, // 토큰이 있을 경우에만 쿼리를 활성화
  });
  // 로그인 상태를 확인하거나 변경하는 로직을 구현합니다.
  // 예제를 단순화하기 위해, localStorage를 사용하여 로그인 상태를 흉내냅니다.
  useEffect(() => {
    if (!isLoading && !isError && data) {
      // 유저 정보를 성공적으로 가져왔다면, currentUser 상태 업데이트

      setCurrentUser(data.user);
    }
  }, [data, isLoading, isError]);

  const login = (userCredentials) => {
    // 로그인 로직 구현
    // 성공 시 currentUser 상태를 업데이트하고 localStorage에 저장합니다.
    setCurrentUser(userCredentials.user);
    localStorage.setItem("token", userCredentials.token);
    api.defaults.headers.Authorization = `Bearer ${userCredentials.token}`;
    // localStorage.setItem("user", JSON.stringify(userCredentials));
  };

  const logout = () => {
    // 로그아웃 로직 구현
    setCurrentUser(null);
    localStorage.removeItem("token");
  };

  const value = {
    currentUser,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
